import React from 'react';
import styled from 'styled-components';
import { prop } from 'styled-tools';

import { MARKER_TYPE, STYLED_MARKER } from 'components/MarkerSettings/IconOptions';
import { Icon } from 'components/Shared/Icon';

const StyledMarkerPreview = styled.span`
    flex: 0 0 auto;
    display: block;
    position: relative;
    width: 2.25em;
    height: 2.25em;
    margin: -0.5em;
    padding: 0.5em;
    border-radius: 50%;
    overflow: hidden;
    line-height: 1;
    text-align: center;

    &:before {
        content: '';
        position: absolute;
        top: -5px;
        right: -5px;
        bottom: -5px;
        left: -5px;
        background: transparent url(${prop('styleImageUrl')}) center no-repeat;
        background-size: cover;
        filter: blur(1px);
    }
`;

const MarkerImage = styled.img`
    display: inline-block;
    position: relative;
    max-width: 100%;
    max-height: 100%;
`;

const MarkerIcon = styled(Icon)`
    position: relative;
    width: 100%;
    height: 100%;
`;

const MarkerPreviewIcon = ({ icon }) => {
    switch (icon.type) {
        case MARKER_TYPE.DEFAULT:
            const src = 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi.png';
            return <MarkerImage src={src} />;

        case MARKER_TYPE.STYLED:
            const { styledMarkerId, color } = icon;
            const glyph = STYLED_MARKER[styledMarkerId];
            return <MarkerIcon glyph={glyph} color={color} />;

        case MARKER_TYPE.CUSTOM:
            return <MarkerImage src={icon.image.url} />;

        default:
            return null;
    }
};

const MarkerPreview = ({ styleImageUrl, ...props }) => {
    return (
        <StyledMarkerPreview styleImageUrl={styleImageUrl}>
            <MarkerPreviewIcon {...props} />
        </StyledMarkerPreview>
    );
};

export default MarkerPreview;
